import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
      redirectTo: 'home',
      pathMatch: 'full'
  },
  
  {
      path: 'home',
      loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
  },

  {
		path: 'historiconotificaciones',
		loadChildren: () => import('./historiconotificaciones/historiconotificaciones.module').then( m => m.HistoriconotificacionesPageModule)
	},
 
  {
		path: 'historiconotificaciones1',
		loadChildren: () => import('./historiconotificaciones-modelo1/historiconotificaciones-modelo1.module').then( m => m.HistoriconotificacionesModelo1PageModule)
	},
  {
		path: 'graficos',
		loadChildren: () => import('./graficos/graficos.module').then( m => m.GraficosPageModule)
	},
  {
		path: 'graficos2',
		loadChildren: () => import('./graficos2/graficos2.module').then( m => m.Graficos2PageModule)
	},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
